// extracted by mini-css-extract-plugin
export default {"popinalert":"popin-alert_popinalert__7iWFv"};